import { gql } from '@apollo/client';

export const UserBaseFields = gql`
  fragment UserBaseFields on User {
    id
    role
    lastName
    firstName
    slug
    email
  }
`;

export const UserFields = gql`
  fragment UserFields on User {
    id
    role
    subtype
    lastName
    firstName
    slug
    email
    phoneNumber
    isOnboarded
    isEmailSet
    onboardingSteps
    cartSize
    status
    hasPassword
    phoneOptIn
    termsOfServiceOptIn
    hashtags {
      id
      name
    }
    avatarUrl
    avatarKey
    storeDetails {
      id
      athleticLevel
      hasActedOnAutoGeneratedMerch
      storeName
      storeTitle
      bio
      careerStatus
      avatarURL
      socialMediaLink
      description
      coverURL
      facebookLink
      twitterLink
      instagramLink
      tiktokLink
      youtubeLink
      facebookFollowing
      twitterFollowing
      tiktokFollowing
      instagramFollowing
      youtubeFollowing
      birthDate
      gender
      hometown
      hometownState
      hometownCountry
      hometownLongitude
      hometownLatitude
      state
      country
      city
      latitude
      longitude
      signUpFlow
      gymRole
    }
    audience
    sports {
      id
      name
    }
  }
`;

export const AuthorizedUserFields = gql`
  fragment AuthorizedUserFields on AuthorizedUser {
    id
    email
    accessToken
    refreshToken
    role
  }
`;

export const SocialSignUpResponseFields = gql`
  fragment SocialSignUpResponseFields on SocialSignUpResponse {
    socialSession {
      id
      firstName
      lastName
      email
      gender
      birthDate
      name
      provider
      socialAssets {
        id
        link
        name
        followersCount
      }
      sub
    }
  }
`;

export const upcomingParticipatedStreamFields = gql`
  fragment upcomingParticipatedStreamFields on User {
    upcomingParticipatedStream {
      id
      name
      slug
      imageURL
      store {
        id
        slug
      }
    }
  }
`;

export const OTPFields = gql`
  fragment OTPFields on User {
    isEmailVerified
    isPhoneVerified
  }
`;
